<app-section-shell
  sectionId="use-cases"
  sectionClass="use-cases-section"
  sectionTitle="Use cases and Whitepapers"
  [displayResults]="displayResults"
  [pageSizeOptions]="pageSizeOptions"
  [pageSize]="pageSize"
  [currentPage]="currentPage"
  [totalPages]="totalPages"
  [canGoPrev]="canGoPrev"
  [canGoNext]="canGoNext"
  (pageSizeChange)="onPageSizeChange($event)"
  (prevPage)="goToPrevPage()"
  (nextPage)="goToNextPage()">
  @for (useCase of visibleUseCases; track useCase) {
    <div class="case-card" [attr.data-url]="useCase.articleUrl">
      <div class="case-content">
        <h4>{{ useCase.title }}</h4>
        <p>{{ useCase.description }}</p>
      </div>

      <div class="card-actions">
        <button class="favorite-btn" [class.bookmarked]="bookmarkedIds.includes(useCase.id)" (click)="bookmarkToggle.emit(useCase.id); $event.stopPropagation()" aria-label="Favorite">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
          </svg>
        </button>
        <a [href]="useCase.articleUrl" target="_blank" class="card-arrow" (click)="$event.stopPropagation()" aria-label="Open item">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/>
            <polyline points="15 3 21 3 21 9"/>
            <line x1="10" y1="14" x2="21" y2="3"/>
          </svg>
        </a>
      </div>
    </div>
  }
</app-section-shell>
